

/**
 * Vuex.Store getters
 * @author LiQingSong
 */
const getters = {


  // token: (state) => state.user.token,
  // accessTokenProduct: (state) => state.user.accessTokenProduct,
  balance: (state) => state.user.balance,
  taskDetail: (state) => state.user.taskDetail,
  logo: (state) => state.user.logo,
  currentTab: (state) => state.user.currentTab,
  openTopUp: (state) => state.openTopUp,
  currentMenu: (state) => state.currentMenu,

  caihongNo: state => state.user.userInfo.orgInfo.caihongNO, // 获取用户编号

  showInvite: (state) => state.showInvite,
  apolloConfig: (state) => state.apolloConfig, // 获取所有apollo配置
  getApolloConfig: (state) => (key) => state.apolloConfig[key], // 获取单个apollo配置
  authObject: (state) => state.user.authObject, // 所有权限对象
  userInfo: (state) => state.user.userInfo, // 获取登录用户信息
  sseData: (state) => state.sseData, // 获取sse数据
  toolImg: (state) => state.toolImg, // 获取工具图片
  menuList: (state) => state.user.menuList, // 获取菜单列表
  getAuthInfo: (state) => (key) => state.user.authObject[key], // 获取单个权限对象
  curRouterAuth: (state) => state.user.curRouterAuth, // 当前路由权限
  orgFlag: (state) => state.user.userInfo.orgInfo.orgFlag, // 机构标识
  superFlag: (state) => state.user.userInfo.userInfo.superFlag, // 是否超级管理员
  userId: (state) => state.user.userInfo.userInfo.userId, // 用户id
  // -----------------------提示词------------------------
  // 获取提示词是否开启优化
  tipWord: (state) => (key) => {
    let tip = state.apolloConfig["optimize_write_prompt"] || []
    let data = tip.find(item => item.name === key)
    return data || {}
  },
  // ------------------------短信------------------------
  SMS_time: (state) => state.SMS.interval, // 获取发送验证码倒计时
  sendStatus: (state) => state.SMS.sendStatus, // 验证码发生状态
};
export default getters;
